<div class="d-flex justify-content-center mb-5">
  <div class="container position-relative">
    <div class="section-title">
      <app-section-title
        title="Explore By Themes"
        [subtitle]="'Pick as per your preference'"
        inital="Explore"
        [iscursive]="true"
      ></app-section-title>
    </div>

    <app-carousel-navigation
      [swiperInstance]="swiperInstance"
      class="w-100"
    ></app-carousel-navigation>
    <ng-container *ngTemplateOutlet="navigationLeftContent"></ng-container>

    <!-- Swiper Container -->
    <swiper-container
      #swiperCardsContainer
      init="false"
      [slides-per-view]="3"
      [speed]="500"
      [loop]="true"
      [navigation]="false"
      [space-between]="10"
      [free-mode]="true"
      class="swiper-3d curved"
      [breakpoints]="breakpoints"
      appSwiperExtension
      [items]="themes"
    >
      <swiper-slide
        *ngFor="let theme of themes; let i = index"
        class="swiper-slide-3d"
        [ngClass]="{ panel: true, active: i === currentIndex }"
        (click)="
          i === currentIndex && hideExploreNowBtn
            ? redirectToTheme(theme?.slug)
            : onPanelClick(i)
        "
      >
        <div class="overlay"></div>
        <div
          class="swiper-panel-content"
          [ngStyle]="{
            'background-image':
              'url(' +
              (theme?.thumbnail?.cdnUrl ||
                'https://creativelayers.net/themes/viatours-html/img/features/2/1.jpg') +
              ')',
            'background-size': 'cover',
            'background-position': 'center'
          }"
        >
          <!-- <div class="badge rounded-pill badge-count position-absolute">
        {{theme?.totalCount}} Packages
        </div> -->
          <h1 class="z-index">{{ theme?.name || "Unknown Theme" }}</h1>
          @if(i===currentIndex && !hideExploreNowBtn){
          <a
            [routerLink]="['/', modifiedSlug(theme?.slug)]"
            [state]="{
              theme: theme?._id,
              sortBy: 'price',
              sortOrder: 'asc',
              page: 1,
              limit: 15,
            }"
          >
            <app-button
              class="explore-btn slim secondary-non-transparent z-index"
              >Explore</app-button
            >
          </a>
          }
        </div>
      </swiper-slide>
    </swiper-container>

    <app-no-result-found
      *ngIf="themes?.length === 0 && isLoading"
      heading="No Themes to show!"
    ></app-no-result-found>
  </div>
</div>
